var map = {
	"./btn-back-pressed.svg": "Emby",
	"./btn-close-pressed.svg": "IVqF",
	"./btn-delete-employee-pressed.svg": "L8Y6",
	"./btn-edit-status-pressed.svg": "Lo38",
	"./btn-employee-pressed.svg": "sjai",
	"./btn-enter-pressed.svg": "mzy9",
	"./btn-menu-pressed.svg": "tJ6q",
	"./btn-profile-pressed.svg": "ApMY",
	"./btn-radio-button-selected-pressed.svg": "uWyn",
	"./btn-radio-button-unselected-pressed.svg": "ceWH",
	"./btn-settings-pressed.svg": "0YaL",
	"./btn-upload-pressed.svg": "1NOk",
	"./ic-menu-employee-pressed.svg": "ndW7",
	"./ic-menu-facilities-pressed.svg": "l8Al",
	"./ic-menu-immunity-passport-pressed.svg": "71xP",
	"./ic-menu-information-pressed.svg": "TFzs"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "UyZ5";